import { useRef } from "react";
import { useAnimationFrame } from '../hooks/useAnimationFrame';
import '../styles/Skills.css';

const SkillCube = () => {
    const ref = useRef(null);

    useAnimationFrame((t) => {
        if (!ref.current) return;
        const rotate = Math.sin(t / 10000) * 200;
        const y = (1 + Math.sin(t / 1000)) * -50;
        ref.current.style.transform = `translateY(${y}px) rotateX(${rotate}deg) rotateY(${rotate}deg)`;
    });

    return (
        <div className="cube-container">
            <div className="cube" ref={ref}>
                <div className="side front">
                    <img src="./images/skillsImg/react.webp" alt="React" />
                </div>
                <div className="side left">
                    <img src="./images/skillsImg/html.png" alt="HTML" />
                </div>
                <div className="side right">
                    <img src="./images/skillsImg/python.png" alt="Python" />
                </div>
                <div className="side top">
                    <img src="./images/skillsImg/js.png" alt="JavaScript" />
                </div>
                <div className="side bottom">
                    <img src="./images/skillsImg/css.png" alt="CSS" />
                </div>
                <div className="side back">
                    <img src="./images/skillsImg/figma.png" alt="Figma" />
                </div>
            </div>
        </div>
    );
};

export default SkillCube;
